"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var hal_rest_client_1 = require("./hal-rest-client");
var uri_1 = require("./uri");
var clients = {};
var resources = {};
/**
 * create hal rest client
 * if a client with same base already exists, same client is returned
 *
 */
function createClient(basename, options) {
    if (options === void 0) { options = {}; }
    if (!basename) {
        return new hal_rest_client_1.HalRestClient();
    }
    if (!(basename in clients)) {
        clients[basename] = new hal_rest_client_1.HalRestClient(basename, options);
    }
    return clients[basename];
}
exports.createClient = createClient;
/**
 * create HalResource for uri
 */
function createResource(client, c, uri) {
    if (!uri) {
        return new c(client);
    }
    if (typeof uri === "object" && uri.templated) {
        return new c(client, uri);
    }
    var stringURI = typeof uri === "string" ? uri : uri.uri;
    var objectURI = typeof uri === "string" ? new uri_1.URI(uri, false, uri) : uri;
    if (!(stringURI in resources)) {
        resources[stringURI] = new c(client, objectURI);
    }
    var resource = resources[stringURI];
    if (resource instanceof c) {
        return resource;
    }
    return new c(resource);
}
exports.createResource = createResource;
/**
 * reset cache for client or resource
 */
function resetCache() {
    clients = {};
    resources = {};
}
exports.resetCache = resetCache;
//# sourceMappingURL=hal-factory.js.map